import { useEffect, useRef, useState } from "react";

export const FadeIn = ({ children, className = "", as: Tag = "div", ...rest }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, []);
  return (
    <Tag ref={ref} className={`fade-rise ${visible ? "is-visible" : ""} ${className}`} {...rest}>
      {children}
    </Tag>
  );
};
